import Api from '@/services/Api'

export default {
  TrySetLogoutUrl() {
    var rawToken = localStorage.getItem('token');

    if(rawToken){
      var token = this.parseJwt(rawToken);

      if (token.logouturl != null && token.logouturl != "") {
  
        window.logoutUrl = token.logouturl;
      }
    }
  },
  SendLogAction(action) {
    return Api().post('/logaction', action);
  },
  SendSSOChallenge(customer)
  {
    return Api().post('/ssochallenge', customer);
  },
  parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }
}
